var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.loading
    ? _c(
        "div",
        [
          _c(
            "portal",
            { attrs: { to: "ads-container-top" } },
            [
              _c("ci-suggested-external-content", {
                attrs: { type: "display", id: _vm.adIds.header },
              }),
            ],
            1
          ),
          _c(
            "portal",
            { attrs: { to: "ads-container-right" } },
            [
              _c("ci-suggested-external-content", {
                attrs: { type: "skyscraper", id: _vm.adIds.skyscraper },
              }),
              _c("ci-suggested-external-content", {
                attrs: { type: "sidebar", id: _vm.adIds.sidebar_2nd },
              }),
            ],
            1
          ),
          _c("ci-slider-sticky-wrapper", {
            attrs: { "has-slider": !!_vm.routeHasArchiveQuery },
            scopedSlots: _vm._u(
              [
                _vm.content
                  ? {
                      key: "default",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "article-details",
                              attrs: {
                                id: "article",
                                "data-series": _vm.content.article_series_id,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row no-gutters-handheld" },
                                [
                                  _c(
                                    "article",
                                    {
                                      staticClass:
                                        "article-details__main col-12 col-xl-9 col-xxl-8",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "ci-card" },
                                        [
                                          _vm.content.content_type ===
                                            "Video" ||
                                          (_vm.content.content_type ===
                                            "Webcast" &&
                                            _vm.content.content_url)
                                            ? [
                                                _vm.content.gated
                                                  ? _c(
                                                      "ci-gating",
                                                      {
                                                        staticClass:
                                                          "article-body",
                                                        attrs: {
                                                          location: "video",
                                                          "force-gating": true,
                                                          "teaser-height":
                                                            "auto",
                                                          "gating-rule":
                                                            _vm.content
                                                              .gating_rule,
                                                          "learn-more-tracking-data":
                                                            _vm.trackingData,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "article-details__image",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                sizes:
                                                                  "min-width(1300px) 75vw, 100vw",
                                                                srcset:
                                                                  _vm.heroImgSrcSet,
                                                                src: _vm.content
                                                                  .hero_image
                                                                  .url,
                                                                alt: _vm.content
                                                                  .title,
                                                                width: "100%",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("ci-media-consent", {
                                                      attrs: {
                                                        source:
                                                          _vm.content
                                                            .media_type,
                                                        "source-media-id":
                                                          _vm.content.media_id,
                                                      },
                                                    }),
                                              ]
                                            : _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "article-details__image",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      id: "hero-image",
                                                      srcset: _vm.heroImgSrcSet,
                                                      src: _vm.content
                                                        .hero_image.url,
                                                      alt: _vm.content.title,
                                                      width: "100%",
                                                    },
                                                  }),
                                                ]
                                              ),
                                          _c("ci-contents-actions", {
                                            attrs: { content: _vm.content },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "article-details__content ci-content-padding",
                                            },
                                            [
                                              _vm.content.gated &&
                                              _vm.content.content_type !==
                                                "Video" &&
                                              !(
                                                _vm.content.content_type ===
                                                  "Webcast" &&
                                                _vm.content.content_url
                                              )
                                                ? _c(
                                                    "ci-gating",
                                                    {
                                                      staticClass:
                                                        "article-body",
                                                      attrs: {
                                                        location: "article",
                                                        "force-gating": true,
                                                        "teaser-height": "auto",
                                                        "gating-rule":
                                                          _vm.content
                                                            .gating_rule,
                                                        "learn-more-tracking-data":
                                                          _vm.trackingData,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "ci-contents-article",
                                                        {
                                                          attrs: {
                                                            content:
                                                              _vm.content,
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("ci-contents-article", {
                                                    attrs: {
                                                      content: _vm.content,
                                                    },
                                                  }),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                  _c("ci-contents-sidebar", {
                                    attrs: {
                                      content: _vm.content,
                                      "related-products": _vm.relatedProducts,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                _vm.routeHasArchiveQuery
                  ? {
                      key: "sliderContent",
                      fn: function (slotProps) {
                        return [
                          _c("ci-related-newsletter-content-list", {
                            attrs: {
                              "show-small-teaser": !!slotProps.windowIsScrolled,
                            },
                          }),
                        ]
                      },
                    }
                  : null,
                _vm.content && _vm.content.id
                  ? {
                      key: "otherContent",
                      fn: function () {
                        return [
                          _c("ci-related-content-list", {
                            staticClass: "article-details__related",
                            attrs: { "content-id": _vm.content.id },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }